// Gli errori DRF arrivano come {campo: ["messaggio"]}, {detail: "..."}, liste o stringhe.
// Qui diventano una frase italiana: nessuna pagina deve più mostrare JSON all'utente.
const ETICHETTE = {
  detail: '', non_field_errors: '', __all__: '',
  connection: 'Account WhatsApp', calendar: 'Calendario', contacts: 'Destinatari',
  name: 'Nome', title: 'Titolo', phone: 'Numero', email: 'Email', notes: 'Note',
  rrule: 'Ripetizione', tzid: 'Fuso orario', version: 'Versione',
  dtstart_local: 'Inizio', dtend_local: 'Fine', members: 'Membri',
  starts_local: 'Primo invio', body: 'Testo', prefix: 'Prefisso',
};

function appiattisci(valore) {
  if (valore == null) return [];
  if (typeof valore === 'string') return [valore];
  if (Array.isArray(valore)) return valore.flatMap(appiattisci);
  if (typeof valore === 'object') {
    return Object.entries(valore).flatMap(([chiave, dentro]) => {
      const etichetta = ETICHETTE[chiave] ?? chiave;
      return appiattisci(dentro).map(testo => (etichetta ? `${etichetta}: ${testo}` : testo));
    });
  }
  return [String(valore)];
}

const PER_STATO = {
  401: 'Sessione scaduta: rientra per continuare.',
  403: 'Non hai i permessi per questa operazione.',
  404: 'Elemento non trovato: potrebbe essere stato eliminato.',
  409: 'Qualcuno ha modificato questo elemento nel frattempo: ricarica e riprova.',
  413: 'File troppo grande.',
  429: 'Troppe richieste: attendi qualche secondo.',
  500: 'Errore del server. Se si ripete, controlla i log.',
  502: 'Il servizio non risponde.',
  503: 'Il servizio non è disponibile in questo momento.',
};

// Una pagina di errore del server è HTML: non va mai riversata nell'interfaccia.
const sembraHtml = (valore) => typeof valore === 'string'
  && /^\s*(<!doctype|<html|<\?xml|<body|<div|<pre)/i.test(valore);

export function messaggioErrore(errore, ripiego = 'Operazione non riuscita. Riprova.') {
  if (!errore) return ripiego;
  if (errore.code === 'ERR_CANCELED' || errore.name === 'CanceledError') return '';
  if (!errore.response) return 'Server non raggiungibile: controlla la connessione.';

  const { data, status } = errore.response;
  if (sembraHtml(data) || data instanceof Blob || data instanceof ArrayBuffer) {
    return PER_STATO[status] || `Errore del server (${status}). Controlla i log di Django.`;
  }

  // Le API avvolgono gli errori in {error, message, detail, status_code}:
  // il dettaglio per campo è la parte utile, il resto è impalcatura.
  const utile = (data && typeof data === 'object' && 'detail' in data && 'error' in data)
    ? data.detail
    : data;

  const frasi = appiattisci(utile)
    .map(t => String(t).trim())
    .filter(t => t && !sembraHtml(t))
    .map(t => (t.length > 300 ? `${t.slice(0, 300)}…` : t));
  if (frasi.length) return frasi.slice(0, 3).join(' · ');
  return PER_STATO[status] || ripiego;
}

// Errori per campo, per mostrarli sotto l'input invece che in cima alla pagina.
export function erroriPerCampo(errore) {
  let dati = errore?.response?.data;
  if (dati && typeof dati === 'object' && 'detail' in dati && 'error' in dati) dati = dati.detail;
  if (!dati || typeof dati !== 'object' || Array.isArray(dati)) return {};
  return Object.fromEntries(
    Object.entries(dati)
      .filter(([chiave]) => !['detail', 'non_field_errors', '__all__'].includes(chiave))
      .map(([chiave, valore]) => [chiave, appiattisci(valore).join(' ')])
      .filter(([, testo]) => testo)
  );
}

export default messaggioErrore;
